/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocationsResponse } from '../../models/locations-response';

export interface GetLocations$Params {

/**
 * Repeatable parameter with value format resource_type:resource_id. resource_type is the types supported in Resource#type and resource_id is the id of that resource.
 */
  requestedResources?: Array<string>;
}

export function getLocations(http: HttpClient, rootUrl: string, params?: GetLocations$Params, context?: HttpContext): Observable<StrictHttpResponse<LocationsResponse>> {
  const rb = new RequestBuilder(rootUrl, getLocations.PATH, 'get');
  if (params) {
    rb.query('requestedResources', params.requestedResources, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LocationsResponse>;
    })
  );
}

getLocations.PATH = '/api/v1/location';
